import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// --- PUBLIC PAGES ---
import Home from "./Pages/HomePage/home";
import Collection from "./Pages/CollectionPage/collection";
import ArchivalProducts from "./Components/ArchiveProducts/ArchivalProducts";
import CartPage from "./Components/Cart/Cart";
import OrderPage from "./Components/OrderPage/OrderPage";
import OrderSuccessPage from "./Components/OrderSuccessPage/OrderSuccessPage";

// --- RETAILER PAGES ---
import RetailerLogin from "./Pages/RetailerPannel/RetailerLogin";
import RetailerDashboard from "./Pages/RetailerPannel/RetailerDashboard/RetailerDashboard";
import CreateRetailerOrder from "./Pages/RetailerPannel/CreateRetailerOrder/CreateRetailerOrder";
import RetailerCatalogue from "./Pages/RetailerPannel/RetailerCatalogue/RetailerCatalogue";
import RetailerOrders from "./Pages/RetailerPannel/RetailerOrders/RetailerOrders";
import RetailerProfile from "./Pages/RetailerPannel/RetailerProfile/RetailerProfile";
// --- ADMIN PAGES ---
import AdminDashboard from "./Pages/Admin/Dashboard";
import Products from "./Pages/Admin/Products/AllProducts";
import AddProduct from "./Pages/Admin/Products/AddProduct";
import AddCategory from "./Pages/Admin/Categories/AddCategories";
import AllCategories from "./Pages/Admin/Categories/AllCategories";
import AdminLogin from "./Pages/Admin/Admin Login/AdminLogin";
import CustomersPage from "./Pages/Admin/Customers/Customers";
import CreateOrder from "./Pages/Admin/Create Order/createOrder";
import PartyPage from "./Pages/Admin/Party/party";
import OrderList from "./Pages/Admin/Orders/PartyOrders";

// --- LAYOUTS ---
import MainLayout from "./layout/MainLayout";
import AdminLayout from "./layout/AdminLayout";
import RetailerLayout from "./layout/RetailerLayout";

// --- ROUTE PROTECTIONS (UPDATED) ---
import { RequireAdmin, GuestAdmin } from "./AdminRoutes";
import { RequireRetailer, GuestRetailer } from "./RetailerRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* =========================================
            1. 🌐 PUBLIC WEBSITE
        ========================================= */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/Checkout" element={<OrderPage />} />
          <Route path="/order-success" element={<OrderSuccessPage />} />
          <Route
            path="/collection/:categoryName"
            element={<ArchivalProducts />}
          />
        </Route>

        {/* =========================================
            2. 📱 RETAILER B2B PORTAL
        ========================================= */}
        {/* 🚪 GUEST: Only visible if NOT logged in as a Retailer */}
        <Route element={<GuestRetailer />}>
          <Route
            path="/retailer/login"
            element={
              <RetailerLogin
                onLoginSuccess={() => (window.location.href = "/retailer")}
              />
            }
          />
        </Route>

        {/* 🔒 PROTECTED: Only visible if logged in as a Retailer */}
        <Route element={<RequireRetailer />}>
          <Route element={<RetailerLayout />}>
            <Route path="/retailer" element={<RetailerDashboard />} />
            <Route
              path="/retailer/new-order"
              element={<CreateRetailerOrder />}
            />
            <Route path="/retailer/catalogue" element={<RetailerCatalogue />} />
            <Route
              path="/retailer/retailers-orders"
              element={<RetailerOrders />}
            />

            <Route path="/retailer/profile" element={<RetailerProfile />} />
          </Route>
        </Route>

        {/* =========================================
            3. 🖥️ ADMIN CONTROL PANEL
        ========================================= */}
        {/* 🚪 GUEST: Only visible if NOT logged in as an Admin */}
        <Route element={<GuestAdmin />}>
          <Route path="/admin/login" element={<AdminLogin />} />
        </Route>

        {/* 🔒 PROTECTED: Only visible if logged in as an Admin */}
        <Route element={<RequireAdmin />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/products" element={<Products />} />
            <Route path="/admin/products/add" element={<AddProduct />} />
            <Route path="/admin/categories" element={<AllCategories />} />
            <Route path="/admin/categories/add" element={<AddCategory />} />
            <Route path="/admin/create-order" element={<CreateOrder />} />
            <Route path="/admin/party-orders" element={<OrderList />} />
            <Route path="/admin/customers" element={<CustomersPage />} />
            <Route path="/admin/parties" element={<PartyPage />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
